import _ from 'lodash';

// 多语言id
export const localeMap = [
  {
    value: 3,
    label: '简体中文'
  },
  {
    value: 2,
    label: '繁體中文'
  },
  {
    value: 1,
    label: 'English'
  },
  {
    value: 4,
    label: 'Bahasa Indonesia'
  },
  {
    value: 5,
    label: '日本語'
  },
  {
    value: 6,
    label: '한국어'
  },
  {
    value: 7,
    label: 'Tiếng Việt'
  },
  {
    value: 8,
    label: 'ภาษาไทย'
  },
  {
    value: 9,
    label: 'हिन्दी'
  }
];

// 多语言key
export const localeKeys = [
  'cn',
  'hk',
  'en',
  'id',
  'ja',
  'ko',
  'vi',
  'th',
  'hi'
];

// 多语言 label
export const localeLabelMap = {
  cn: '简体中文',
  hk: '繁體中文',
  en: 'English',
  id: 'Bahasa Indonesia',
  ja: '日本語',
  ko: '한국어',
  vi: 'Tiếng Việt',
  th: 'ภาษาไทย',
  hi: 'हिन्दी'
};

// 多语言 flag
export const localeFlagMap = {
  cn: '🇨🇳',
  hk: '🇭🇰',
  en: '🇺🇸',
  id: '🇮🇩',
  ja: '🇯🇵',
  ko: '🇰🇷',
  vi: '🇻🇳',
  th: '🇹🇭',
  hi: '🇮🇳'
};

// 多语言key转value
export const localeKeyToValueMap = {
  cn: 'zh-CN',
  hk: 'zh-HK',
  en: 'en',
  id: 'id-ID',
  ja: 'ja-JP',
  th: 'th-TH',
  hi: 'hi-IN',
  ko: 'ko-KR',
  vi: 'vi-VN'
};

// 多语言key转value（腾讯验证插件使用）
export const localeKeyToValueTencentMap = {
  cn: 'zh-cn',
  hk: 'zh-hk',
  en: 'en',
  id: 'id',
  ja: 'ja',
  ko: 'ko',
  vi: 'vi',
  th: 'th',
  hi: 'hi'
};

// 多语言value转key
export const localeValueToKeyMap = {
  'zh-CN': 'cn',
  'zh-HK': 'hk',
  'zh-TW': 'hk',
  'en-US': 'en',
  en: 'en',
  'id-ID': 'id',
  'ja-JP': 'ja',
  ja: 'ja',
  'th-TH': 'th',
  th: 'th',
  'hi-IN': 'hi',
  hi: 'hi',
  vi: 'vi',
  'vi-VN': 'vi',
  'ko-KR': 'ko',
  ko: 'ko'
};

const initSpace = (value, key = window.VM.$i18n.locale) => {
  const space = _.includes(['en', 'id', 'th', 'hi', 'vi'], key) ? ' ' : '';
  return `${value[0]}${space}${value[1]}`;
};
// 本地多语言转对应值
export const localeKeyToValue = (key, number = '') => {
  const value = {
    value: initSpace([window.VM.$t(key), number]),
    i18nValue: {}
  };
  _.forEach(localeKeys, (v) => {
    value.i18nValue[v] = initSpace([window.VM.$t(key, v), number], v);
  });
  return value;
};

// 返回用于显示的多语言值
export const getLocaleValue = (data, locale = window.VM.$i18n.locale) => {
  if (!data || typeof data === 'string') {
    return data;
  }
  return data.i18nValue[locale] || data.value;
};
